import { Module } from 'vuex';
import { cloneDeep } from 'lodash';
import { Store } from '@/store/types';
import { SnackbarState } from '../types';
import { snackbarGetters } from './getters';
import { snackbarActions } from './actions';
import { snackbarMutations } from './mutations';
import { snackbarStateDefaults } from './defaults';

export const snackbarState: Module<SnackbarState, Store> = {
  namespaced: true,
  state: cloneDeep(snackbarStateDefaults),
  getters: snackbarGetters,
  actions: snackbarActions,
  mutations: snackbarMutations
};
